const t = {
  name: "DocumentCheckmark1",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 3C5 2.44772 5.44771 2 6 2H12V6C12 7.65685 13.3431 9 15 9H19V14H21V6.58579L14.4142 0H6C4.34315 0 3 1.34314 3 3V21C3 22.6569 4.34315 24 6 24H12V22H6C5.44772 22 5 21.5523 5 21V3ZM14 2.41421L18.5858 7H15C14.4477 7 14 6.55228 14 6V2.41421Z" fill="currentColor"/>
<path d="M23.4144 17.9981L18.0002 23.4123L14.5859 19.9981L16.0002 18.5839L18.0002 20.5839L22.0002 16.5839L23.4144 17.9981Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as DocumentCheckmark1
};
